module.exports = __webpack_public_path__ + "img/flowscore-white.e939b342.png";